module.exports = __webpack_public_path__ + "img/hero.0c91ea1b.png";